import { Map } from 'immutable';

export const alertMessageModalInitialState = new Map({
  isOpen: false,
  content: '',
  isExpanded: true,
});

const createAlertMessageModalReducer = ({
  OPEN_MODAL,
  CLOSE_MODAL,
  UPDATE_CONTENT,
  TOGGLE_CONTENT,
  OPEN_MODAL_AND_UPDATE_CONTENT
}) => (state = alertMessageModalInitialState, action) => {
  switch (action.type) {
    case OPEN_MODAL:
      return state.set('isOpen', true);
    case CLOSE_MODAL:
      return state.set('isOpen', false);
    case UPDATE_CONTENT:
      return state.set('content', action.payload.content);
    case TOGGLE_CONTENT:
      return state.set('isExpanded', !state.get('isExpanded'));
    case OPEN_MODAL_AND_UPDATE_CONTENT:
      return state.merge({ isOpen: true, content: action.payload.content });
    default:
      return state;
  }
};

export default createAlertMessageModalReducer;
